import ModalWrappedContent from '@/components/basicComponents/modal/modalWrappedContent';
import { formatUserPhoneNumber } from '@/components/settings-page/users/firmTable/tableBody';
import { useAuth } from '@/hooks/use-auth';
import { themeVar } from '@/styles/theme';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

interface ChangePhoneNumberProps {
  isOpen: boolean;
  onClose: () => void;
}

const ChangePhoneNumber = ({ isOpen, onClose }: ChangePhoneNumberProps) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const onSave = () => {
    navigate('/two-factor-authentication', { state: { changeMobileNumber: true } });
  };

  return (
    <ModalWrappedContent
      isOpen={isOpen}
      onClose={onClose}
      title="Change Mobile Phone Number"
      confirmButton={{
        name: 'Continue',
        onClick: onSave
      }}
    >
      <ModalDescription color={themeVar('font.base')}>
        Are you sure you want to change the mobile phone number associated with your account?
      </ModalDescription>
      <PhoneNumber>{formatUserPhoneNumber(user?.mobileNumberCountryCode, user?.mobileNumber)}</PhoneNumber>
      <br />
      <ModalDescription color={themeVar('font.weak')}>
        Upon continuing you will be asked to provide your new phone number. Upon verification of your new phone number you will need to sign in again.
      </ModalDescription>
    </ModalWrappedContent>
  );
};

export default ChangePhoneNumber;

const ModalDescription = styled.div<{ color: string }>`
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 22.4px;
  color: ${({ color }) => color};
`;

const PhoneNumber = styled.p`
  text-align: center;
  font-size: 19px;
  font-weight: 700;
  line-height: 28px;
  color: ${({ theme }) => theme.font.base};
`;
